import React from 'react'
import useData from '../hooks/useData'
import Loading from './Loading'
import AmazonProductRow from './AmazonProductRow'

const CompetitorLinkList = props => {
    const Links = useData('competitor_link/?competitor_page_id=' + props.competitor_page_id)

    return (
        <>
            {(Links.data && Array.isArray(Links.data) && Links.data.length && (
                <table className='table table-responsive'>
                    <tbody>{Links.data && Links.data.map((link, index) => <AmazonProductRow {...link.provider_details} index={index + 1} reviews={props.reviews} originalUrl={props.originalUrl} displayUrl={props.displayUrl} origin={props.origin} key={`link-product-${link.id}`} />)}</tbody>
                </table>
            )) ||
                (Links.isLoading && <Loading text={'Fetching links from ' + props.title} />) ||
                null}
        </>
    )
}

export default CompetitorLinkList
